import { GameStore } from '@GameStore/GameStore';
import { EGameStoreKeys, IBetState } from '@GameStore/GameStoreSchema';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';

export class BetManager {
    private readonly gameStore: GameStore;
    private currentState: IBetState;

    constructor(gameStore: GameStore) {
        this.gameStore = gameStore;
        this.gameStore.on(EGameStoreKeys.BetState, () => {
            this.currentState = this.gameStore.get(EGameStoreKeys.BetState);
        });
    }

    private updateBetState(index: number) {
        const value = this.currentState.betSteps[index];
        this.gameStore.set(EGameStoreKeys.BetState, { ...this.currentState, ...{ value: value, index: index } });
        EventsCenter.emit(EGameEvents.BET_UPDATE, { ...this.currentState, ...{ value: value, index: index } });
    }

    public increase() {
        if (this.currentState.index < this.currentState.maxIndex) {
            const newIndex = this.currentState.index + 1;
            this.updateBetState(newIndex);
        }
    }

    public descrease() {
        if (this.currentState.index > 0) {
            const newIndex = this.currentState.index - 1;
            this.updateBetState(newIndex);
        }
    }

    public setIndex(index: number) {
        const newIndex = index;
        this.updateBetState(newIndex);
    }

    public getBetValue(index: number): number {
        return this.currentState.betSteps[index].raw;
    }

    public getBetIndex(value: number): number {
        return this.currentState.betSteps.findIndex((betStep) => betStep.raw === value);
    }

    public getCurrentSpinBet(): number {
        const isSpecialGame = this.gameStore.get(EGameStoreKeys.IsLockAndRollMode) || this.gameStore.get(EGameStoreKeys.IsFreeGamesMode);
        const bet = isSpecialGame ? 0 : this.currentState.value.raw;
        return bet;
    }
}
